import { InboxEventAction, InboxStatus } from '_graphql/__generated__/globalTypes';
import { SupplierInbox_supplierInbox } from '_graphql/queries/__generated__/SupplierInbox';
import { SupplierInboxUpdated_supplierInboxUpdated } from '_graphql/subscriptions/__generated__/SupplierInboxUpdated';

export const OPEN_INBOX_VARIABLES = {
  filter: { status: InboxStatus.OPEN },
  pagination: { limit: 100, offset: 0 },
};

export function applyInboxEvent(
  items: SupplierInbox_supplierInbox[],
  event: SupplierInboxUpdated_supplierInboxUpdated,
): SupplierInbox_supplierInbox[] {
  if (
    event.action === InboxEventAction.ATTENDED ||
    event.item.status === InboxStatus.ATTENDED
  ) {
    return items.filter((row) => row.id !== event.item.id);
  }

  const index = items.findIndex((row) => row.id === event.item.id);
  if (index === -1) {
    return [event.item, ...items];
  }

  const next = items.slice();
  next[index] = event.item;
  return next;
}

export function nextInboxCount(
  items: SupplierInbox_supplierInbox[],
  count: number,
  event: SupplierInboxUpdated_supplierInboxUpdated,
): number {
  const existed = items.some((row) => row.id === event.item.id);
  if (
    event.action === InboxEventAction.ATTENDED ||
    event.item.status === InboxStatus.ATTENDED
  ) {
    return existed ? Math.max(0, count - 1) : count;
  }
  if (event.action === InboxEventAction.OPENED && !existed) {
    return count + 1;
  }
  return count;
}
